import { Badge } from "@/components/ui/badge";

export const StatusBadge = ({ status }: { status: string }) => {
	const normalizedStatus = status.toUpperCase();

	const statusStyles = {
		ACTIVE: "bg-green-500 text-white",
		CONFIRMED: "bg-amber-200 text-amber-900",
		REQUEST: "bg-yellow-200 text-yellow-900",
		HOLD: "bg-red-500 text-white",
		OPEN: "bg-yellow-100 text-yellow-800",
		COMPLETE: "bg-yellow-200 text-yellow-900",
		CLOSED: "bg-slate-200 text-slate-700",
	};

	return (
		<Badge
			className={
				statusStyles[normalizedStatus as keyof typeof statusStyles] ??
				"bg-slate-200 text-slate-800"
			}
		>
			{normalizedStatus}
		</Badge>
	);
};
